<template>
  <span
    class="v-btn v-btn--icon v-btn--outline v-btn--small theme--light ma-0 pa-0"
  >{{ value }}</span>
</template>
<script>
export default {
  props: ["value"],
};
</script>
